/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.

<template>
  <div
    v-if="loaded"
    class="col-lg-10 assignment-edit-attachments"
  >
    <h2>
      Supporting Materials
    </h2>
    <br>
    <div
      v-if="assignment.attachments && assignment.attachments.length"
      style="margin-bottom: 40px;"
    >
      <assignment-attachment-list
        :assignment="assignment"
        :show-trash-can="true"
        @attachmentDeleted="assignmentModified"
      />
    </div>
    <div
      v-else
    >
      If you do not wish to add any supporting materials, simply click "Save and Continue" below.
      <br><br>
    </div>

    <h2
      id="add-attach-nav"
      class="sr-only"
    >
      Add Attachment Navigation
    </h2>
    <nav aria-labelledby="add-attach-nav">
      <ul
        class="nav nav-tabs"
      >
        <li
          :class="{ active: tab === 'add-recording' }"
        >
          <a
            id="add-recording-link"
            ref="add-recording-link"
            href="#"
            @click.prevent="loadTab('add-recording')"
            @keypress="loadTab('add-recording', $event)"
          >
            Add Recording
          </a>
        </li>
        <li
          :class="{ active: tab === 'add-attachment' }"
        >
          <a
            id="add-attachment-link"
            ref="add-attachment-link"
            href="#"
            @click.prevent="loadTab('add-attachment')"
            @keypress="loadTab('add-attachment', $event)"
          >
            Add Link to File
          </a>
        </li>
      </ul>
    </nav>
    <div
      v-if="tab === 'add-attachment'"
      id="add-attachment-container-parent"
      class="tab-well"
      aria-labelledby="add-attachment-header"
    >
      <assignment-add-attachment
        @saveAttachment="saveAttachment"
      />
    </div>
    <div
      v-if="tab === 'add-recording'"
      id="add-recording-container-parent"
      class="tab-well"
      aria-labelledby="add-recording-header"
    >
      <assignment-add-recording
        @saveAttachment="saveAttachment"
      />
    </div>

    <br><br>
    <button
      type="button"
      class="btn clear-btn"
      @click="$emit('rewindAssignmentEditor')"
    >
      Cancel / Previous
    </button>
    <button
      type="button"
      class="btn btn-primary"
      style="float:right"
      @click="saveAndContinue"
    >
      Save and Continue
    </button>
  </div>
</template>


<style lang="less" scoped>
  .nav-tabs li {
    width: 120px;
  }
</style>
<style lang="less">
  /* This is a bit of a hack to give attachments a border on this page
     but not elsewhere when the same component is used
   */
  div.assignment-edit-attachments div.attachment {
    border: 1px solid #999;
  }
</style>

<script>
import AssignmentAddAttachment from '../forms/AssignmentAddAttachment';
import AssignmentAddRecording from '../forms/AssignmentAddRecording';
import AssignmentAttachmentList from '../forms/AssignmentAttachmentList';

export default {
  components: {AssignmentAddAttachment, AssignmentAddRecording, AssignmentAttachmentList},
  props: [ 'assignment' ],
  data() {
    return {
      tab: 'add-recording',
      errors: [],
      saving: false,
      loaded: false,
    };
  },
  computed: {
    activeGroups: {
      cache: false,
      get() {
        return this.$store.getters.activeGroups;
      }
    },
  },
  created() {
    // Make sure we have these for the add-recordings form
    const promises = [this.$store.dispatch('listRecordings')];
    this.activeGroups.forEach((g) => promises.push(this.$store.dispatch('listGroupRecordings', g)));
    window.Promise.all(promises).then(() => this.loaded = true);
  },
  methods: {
    loadTab(identifier, evt) {
      if (evt && evt.key && evt.key === 'Tab') {
        // Firefox bug fix
        return true;
      }

      this.tab = identifier;
      this.$announcer.set(`The ${identifier} tab has been activated. The associated page content is now available below.`);
      document.getElementById(identifier + '-link').blur();
    },
    saveAttachment(args) {
      if (this.assignment.assignmentId) {
        let newAttachments = [args.attachment];
        this.$store.dispatch(
          'updateAssignment',
          { assignment: this.assignment,
            newAttachments }
        ).then(() => {
          // Update the page to show the new attachment
          this.assignment.attachments.push(args.attachment);
          this.assignmentModified();
        }).catch(() => {
          this.saving = false;
        });
      }
    },
    assignmentModified() {
      return this.$emit('assignmentModified');
    },
    saveAndContinue() {
      if (document.getElementById('attachmentSaveButton')) {
        document.getElementById('attachmentSaveButton').click();
        return window.setTimeout(() => this.$emit('advanceAssignmentEditor'), 1000);
      }
      return this.$emit('advanceAssignmentEditor');
    }
  }
};
</script>
